import { type AriaAttributes, type ReactNode } from 'react'
import cx from 'classnames'
import styles from './Badge.module.css'
import { m, AnimatePresence } from 'motion/react'

export interface BadgeProps extends AriaAttributes {
  children?: ReactNode

  /**
   * Does not render the badge when true.
   * Use this to toggle visibility for animations to take effect.
   */
  hidden?: boolean

  /**
   * Test ID attribute.
   */
  testId?: string
}

/**
 * An unread badge is a visual indicator displayed next to an element
 * to signify that there are new, unseen messages or updates that require
 * the user's attention.
 */
export function Badge({ children, hidden, testId, ...rest }: BadgeProps) {
  return (
    <span {...rest} className={cx(styles.root)}>
      <AnimatePresence initial={false}>
        {!hidden && (
          <m.div
            initial={{ opacity: 0, scale: 0.9, y: 2 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 2 }}
            className={styles.badge}
            data-test={testId}
          >
            {children}
          </m.div>
        )}
      </AnimatePresence>
    </span>
  )
}
